export const config = {
    WS_URL: 'wss://dawid.elixir-luxembourg.org/ws',
    WS_USERNAME: 'dawid-frontend',
    WS_PASSWORD: '22RlkCAycnqq%SS$',
    EXTRA_FOOTER: '<p style="text-align: center">\n' +
        '            <span id="doNotTrack-text"><span id="gdpr-result-text">Only necessary cookies accepted</span> - <a\n' +
        '                style="" href="javascript:showBanner();">change</a></span>\n' +
        '        </p>',
    AUTO_PERSIST_LOCAL_STORAGE: false
};
